import React, { PropsWithChildren } from 'react';
import { KeyboardAvoidingView, Platform, StyleSheet } from 'react-native';

import { isWeb } from '~/utils';

// See https://chrisfrewin.medium.com/a-keyboard-avoiding-view-for-react-native-in-2021-196701ff0608

type KeyboardShiftProps = {
    headerHeight?: number;
} & PropsWithChildren<object>;

export function KeyboardShift(props: KeyboardShiftProps) {
    const { headerHeight = 0 } = props;

    const { children } = props;

    // No need to avoid keyboard in web
    if (isWeb()) {
        return <>{children}</>;
    }

    // https://docs.expo.dev/guides/keyboard-handling/#keyboard-avoiding-view
    return (
        <KeyboardAvoidingView
            keyboardVerticalOffset={headerHeight}
            style={styles.container}
            behavior={Platform.OS === 'ios' ? 'padding' : undefined}
        >
            {children}
        </KeyboardAvoidingView>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        width: '100%'
    }
});
